/**
 * Enum for fiscal docs types.
 * @readonly
 * @enum {String} FiscalDocTypeEnum
 */

const FiscalDocTypeEnum = {
  RECEIPT       : 'receipt',
  RECEIPT_CREDIT: 'receipt_credit',

  SERVICE_RECEIPT       : 'service_receipt',
  SERVICE_RECEIPT_CREDIT: 'service_receipt_credit',

  COLLECTION_RECEIPT       : 'receipt_collection',
  COLLECTION_RECEIPT_CREDIT: 'receipt_return',

  INVOICE       : 'invoice',
  INVOICE_CREDIT: 'invoice_credit',

  SERVICE_INVOICE       : 'service_invoice',
  SERVICE_INVOICE_CREDIT: 'service_invoice_credit',

  INVOICE_CREDIT_NO: 'invoice_credit_no',

  FNB       : 'fnb',
  FNB_CANCEL: 'fnb_cancel',
  FNB_RETURN: 'fnb_return',

  RECEIPT_SELF_SUPPLY       : 'receipt_self_supply',
  RECEIPT_SELF_SUPPLY_CREDIT: 'receipt_self_supply_credit',
  RECEIPT_SELF_USE          : 'receipt_self_use',
  RECEIPT_SELF_USE_CREDIT   : 'receipt_self_use_credit',

  NONE: 'none',

  get SELF_DOC_TYPES() {
    return [FiscalDocTypeEnum.RECEIPT_SELF_SUPPLY, FiscalDocTypeEnum.RECEIPT_SELF_USE]
  },
  isSelfDoc: (type) => FiscalDocTypeEnum.SELF_DOC_TYPES.includes(type),

  get RECEIPT_TYPES() {
    return [FiscalDocTypeEnum.RECEIPT, FiscalDocTypeEnum.SERVICE_RECEIPT, FiscalDocTypeEnum.COLLECTION_RECEIPT, FiscalDocTypeEnum.RECEIPT_SELF_SUPPLY, FiscalDocTypeEnum.RECEIPT_SELF_USE]
  },
  isReceipt: (type) => FiscalDocTypeEnum.RECEIPT_TYPES.includes(type),

  get INVOICE_TYPES() {
    return [FiscalDocTypeEnum.INVOICE, FiscalDocTypeEnum.SERVICE_INVOICE]
  },
  isInvoice: (type) => FiscalDocTypeEnum.INVOICE_TYPES.includes(type)

}

export default FiscalDocTypeEnum
